// import { CSSProperties } from "react";

import { CSSProperties } from 'react';

export enum PluginLocation {
    TOP_BAR = 'TOP_BAR'
}

export const GSOCIAL_PLUGIN_ID = 'com.grispi.social';
export const CHAT_PLUGIN_ID = 'com.grispi.chat';
export const TRANSLATE_PLUGIN_ID = 'com.grispi.google-translate';
export const SUBSCRIPTION_PLUGIN_ID = 'com.grispi.subscription';

export enum PluginType {
    CALL = 'CALL',
    PAGE = 'PAGE',
    CHAT = 'CHAT',
    TRANSLATE = 'TRANSLATE',
    RIGHT_PANEL = 'RIGHT_PANEL',
    SMS = 'SMS'
}
export interface PluginManifest {
    title: string;
    global?: boolean;
    singleton?: boolean;
    lazy?: boolean; //default false
    location: PluginLocation;
    pluginId: string;
    src: string;
    uiDefinition: CSSProperties;
    logoUrl?: string;
}
export interface PluginSettings extends Record<string, any> {
    appToken: string;
}
export interface PluginDefinition {
    manifest: PluginManifest;
    name: string;
    enabled: boolean;
    pluginId: string;
    settings: Record<string, any>;
    pluginType: PluginType;
    type: PluginType;
    installed: boolean;
}

export interface PluginUser {
    id: number;
    fullName: string;
    email: string;
    phone: string;
}

export type PluginTicket = Record<string, any>;
export interface PluginContext {
    tenantId: string;
    username: string;
    ticketKey?: string;
    agent: PluginUser;
    requester: PluginUser;
    token: string; // we are keeping this to provide backward compatibility
    accessToken: string;
    initialStatus?: string;
    boundTicketKey?: string;
    refreshToken: string;
    expiresIn: number;
    lang: string;
}
